import script from "./taskfollowup.vue?vue&type=script&lang=ts&setup=true"
export * from "./taskfollowup.vue?vue&type=script&lang=ts&setup=true"

import "./taskfollowup.vue?vue&type=style&index=0&id=2b19e2ea&lang=scss"

const __exports__ = script;

export default __exports__